/**
 * Configuration for KomAds Dashboard
 */

import { IDR } from '@/libs/currency'
import {
  DATE,
  DAY_MONTH_YEAR,
} from '@/libs/filterDate'

export const columnConfig = [
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      width: '60px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
  {
    key: 'partner',
    label: 'Nama Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      minWidth: '200px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
  {
    key: 'top_up_fee',
    label: 'Top Up Fee',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      minWidth: '200px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
  {
    key: 'total_account',
    label: 'Jumlah Akun',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      minWidth: '200px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
  {
    key: 'total_spending',
    label: 'Total Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      minWidth: '150px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
  {
    key: 'revenue',
    label: 'Revenue',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: '600',
      minWidth: '150px',
    },
    tdClass: 'text-[#626262]',
    class: 'p-1',
  },
]

/**
 * Chart options configuration for spending chart
 */
export const chartOptions = {
  series: [],
  resetSeries: {
    shouldUpdateChart: true,
  },
  chart: {
    type: 'area',
    stacked: false,
    height: 350,
    toolbar: { show: false },
    zoom: { enabled: true },
    fontFamily: 'Poppins, sans-serif',
  },
  dataLabels: {
    enabled: false,
  },
  yaxis: {
    labels: {
      formatter: val => IDR(Math.abs(val), 2, 2),
    },
  },
  xaxis: {
    type: 'category',
    categories: [],
    tickAmount: 31,
    labels: {
      formatter: value => DATE(value),
    },
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'],
      opacity: 0.5,
    },
  },
  colors: ['#F95031'],
  legend: {
    show: false,
  },
  noData: { text: 'Tidak Ada Data' },
  tooltip: {
    custom({
      series, seriesIndex, dataPointIndex, w,
    }) {
      const dateValue = DAY_MONTH_YEAR(w.config.xaxis.min[dataPointIndex])

      // Format the tooltip content
      return `
        <div class="custom-tooltip" style="
          background: white;
          border-radius: 8px;
          padding: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          border: 1px solid #E5E5E5;
          font-family: 'Poppins', sans-serif;
        ">
          <div style="font-weight: 600; color: #333; margin-bottom: 4px;">
            Tanggal: ${dateValue || 'Tidak ada data'}
          </div>
          <div style="font-weight: 500; color: #F95031;">
            ${IDR(Math.abs(series[seriesIndex][dataPointIndex]))}
          </div>
        </div>
      `
    },
  },
}

export const chartAreaOptions = {
  resetSeries: {
    shouldUpdateChart: true,
  },
  dataLabels: {
    enabled: false,
  },
  colors: ['#F95031', '#FBBC05'],
  chart: {
    stacked: true,
    stackType: '100%',
    type: 'bar',
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      borderRadius: 8,
      borderRadiusApplication: 'around',
      borderRadiusWhenStacked: 'all',
    },
  },
  xaxis: {
    labels: { show: false },
    axisTicks: { show: false },
    axisBorder: { show: false },
  },
  yaxis: {
    show: false,
    axisTicks: { show: false },
    axisBorder: { show: false },
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'left',
    itemMargin: {
      horizontal: 20,
      vertical: 0,
    },
    markers: {
      shape: 'circle',
      radius: 16,
    },
  },
  fill: {
    opacity: 1,
  },
  grid: {
    show: false,
  },
  tooltip: {
    shared: false,
    fixed: {
      enabled: false,
      position: 'top',
      offsetX: 10,
      offsetY: 8,
    },
    custom({ series, seriesIndex, w }) {
      const {
        color, name, currentValue, title,
      } = w.globals.initialSeries[seriesIndex]
      const value = series[seriesIndex]
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      const isAccount = title && title.toLowerCase().includes('akun')

      return `
      <div class="-top-5">
      <div class="px-1 py-75 flex flex-column"
           style="
             width: 150px;
             border-radius: 16px;
             background: white;
           ">
        <div class="flex items-center gap-3">
          <div style="width: 10px; height: 10px; border-radius: 50%; background-color: ${color};"></div>
          <small>${name}</small>
        </div>
        <span class="font-bold text-[16px] text-black mt-1">${value}</span>
        ${!isAccount ? `<span style="color: #666666; font-size: 12px;">User baru : ${currentValue}</span>` : ''}
      </div>
        <div style="
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #F95031;
      "></div>
      </div>
      `
    },
  },
}
